import React from "react"
import { Link } from "react-router-dom"
import { FaMapMarkerAlt, FaEnvelope, FaExternalLinkAlt, FaUniversity } from "react-icons/fa"
import "./Footer.css"

export function Footer() {
	const currentYear = new Date().getFullYear()

	return (
		<footer className="ncdia-footer">
			<div className="container py-4">
				<div className="row g-4">
					{/* Brand and Description */}
					<div className="col-12 col-lg-5">
						<div className="mb-2">
							<span className="footer-brand-title fw-bold fs-4 text-white">NCDIA</span>
						</div>
						<p className="footer-desc text-white-50 small mb-2">
							Núcleo de Ciência de Dados e Inteligência Artificial da <strong>Universidade de Fortaleza (UNIFOR)</strong>, Fundação Edson Queiroz.
							Pesquisa avançada em IA aplicada à justiça e segurança pública.
						</p>
						<div className="footer-institution d-flex align-items-center gap-2 text-white-50 small">
							<FaUniversity className="text-primary-light" />
							<span>Universidade de Fortaleza · UNIFOR</span>
						</div>
					</div>

					{/* Navigation Links */}
					<div className="col-6 col-lg-3 offset-lg-0 offset-xl-1">
						<h5 className="footer-heading text-white fw-bold fs-6 mb-3">Navegação</h5>
						<ul className="footer-links list-unstyled small mb-0">
							<li className="mb-2">
								<Link to="/">Início</Link>
							</li>
							<li className="mb-2">
								<Link to="/projects">Projetos</Link>
							</li>
							<li className="mb-2">
								<Link to="/publications">Publicações</Link>
							</li>
							<li className="mb-2">
								<Link to="/resources">Recursos</Link>
							</li>
							<li className="mb-0">
								<Link to="/about">Sobre nós</Link>
							</li>
						</ul>
					</div>

					{/* Contact and Location */}
					<div className="col-12 col-sm-6 col-lg-4 col-xl-3">
						<h5 className="footer-heading text-white fw-bold fs-6 mb-3">Localização & Contato</h5>
						<div className="footer-contact text-white-50 small">
							<p className="d-flex align-items-start gap-2 mb-2">
								<FaMapMarkerAlt className="text-primary-light mt-1 flex-shrink-0" />
								<span>Av. Washington Soares, 1321 - Edson Queiroz, Fortaleza - CE</span>
							</p>
							<p className="d-flex align-items-center gap-2 mb-2">
								<FaEnvelope className="text-primary-light flex-shrink-0" />
								<a href="mailto:ncdia@unifor.br" className="text-white-50 text-decoration-none">
									ncdia@unifor.br
								</a>
							</p>
							<a
								href="https://www.unifor.br"
								target="_blank"
								rel="noopener noreferrer"
								className="btn btn-sm btn-outline-light rounded-pill px-3 mt-1 d-inline-flex align-items-center gap-2"
							>
								Portal UNIFOR <FaExternalLinkAlt size={11} />
							</a>
						</div>
					</div>
				</div>

				{/* Unified Copyright Line inside single footer */}
				<div className="footer-copyright-line mt-4 pt-3 border-top border-white border-opacity-10 d-flex flex-wrap justify-content-between align-items-center gap-2 text-white-50 small">
					<span>&copy; {currentYear} NCDIA · Universidade de Fortaleza. Todos os direitos reservados.</span>
					<span>Desenvolvido para pesquisa científica e inovação.</span>
				</div>
			</div>
		</footer>
	)
}
